import { send } from '../../lib/api.js'
import { enumValues, example, fields, resolve } from '../../lib/schema.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- api-try ---
let __fez_component_0;
{
const TOKEN_KEY = 'api_explorer_token'

function readToken() {
  try { return sessionStorage.getItem(TOKEN_KEY) || '' } catch { return '' }
}

function convert(raw, schema, defs) {
  const { schema: s } = resolve(schema, defs)
  const scalar = (value, type) => (type === 'integer' || type === 'number' ? Number(value) : type === 'boolean' ? value === 'true' : value)
  if (s.type === 'array') {
    const itemType = resolve(s.items || {}, defs).schema.type
    return raw.split(',').map((v) => v.trim()).filter(Boolean).map((v) => scalar(v, itemType))
  }
  return scalar(raw, s.type)
}
__fez_component_0 = class {
  PROPS = {
    action: { type: Object, required: true },
    defs: Object,
  }

  init() {
    this.state.token = readToken()
    this.state.sending = false
    this.state.response = null
  }

  beforeRender() {
    const defs = this.props.defs
    const action = this.props.action
    this.state.inputs = fields(action.params, defs).map((field) => {
      const { schema } = resolve(field.schema, defs)
      const values = enumValues(schema) || (schema.type === 'boolean' ? ['true', 'false'] : null)
      const sample = example(field.schema, defs, field.name)
      return {
        ...field,
        options: values ? [{ value: '', label: '(not set)' }, ...values.map((v) => ({ value: String(v), label: String(v) }))] : null,
        placeholder: Array.isArray(sample) ? `${sample.join(', ')} (comma separated)` : String(sample ?? ''),
      }
    })
  }

  async submit(event) {
    event.preventDefault()
    const form = this.formData(event.target)
    const token = (form.__token || '').trim()
    try {
      if (token) sessionStorage.setItem(TOKEN_KEY, token)
      else sessionStorage.removeItem(TOKEN_KEY)
    } catch {}
    const params = {}
    for (const input of this.state.inputs) {
      const raw = (form[input.name] || '').trim()
      if (raw !== '') params[input.name] = convert(raw, input.schema, this.props.defs)
    }
    const ref = (form.__ref || '').trim()
    const path = this.props.action.path.replace('{ref}', ref || '{ref}')
    this.state.sending = true
    const started = performance.now()
    const envelope = await send(path, params, { token })
    this.state.sending = false
    this.state.response = {
      ok: envelope.success,
      status: envelope.status,
      ms: Math.round(performance.now() - started),
      text: JSON.stringify(envelope, null, 2),
    }
  }

  CSS = `:fez {
display:block;form{display:grid;gap:var(--space-4)}.grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:var(--space-4)}.bar{display:flex;align-items:center;justify-content:flex-end;gap:var(--space-3)}.result-slot{margin-top:var(--space-4)}.result{}.head{display:flex;align-items:center;gap:var(--space-2);padding:var(--space-2) var(--space-4);border-bottom:1px solid var(--color-border);background:var(--color-bg-raised);color:var(--color-text-muted);font-size:var(--text-sm)}pre{margin:0;max-height:480px;padding:var(--space-4);overflow:auto;background:var(--color-code-bg);font-size:var(--text-xs);line-height:1.6}
}`

  HTML = `<form class="ui-card tone-muted pad-lg" onsubmit="fez.submit(event)" novalidate>
<ui-input name="__token" type="password" label="Mailbox key" value={state.token} placeholder="48 letters and digits" hint="Optional: a mailbox key, for the actions marked mail. Without it the call uses your browser session. Kept only in this tab." mono></ui-input>
{#if props.action.ref_type}
<ui-input name="__ref" label="{props.action.ref_type} ref" placeholder="{props.action.ref_example}" mono required></ui-input>
{/if}
{#if state.inputs.length}
<div class="grid">
{#each state.inputs as input}
{#if input.options}
<ui-select name={input.name} label={input.name} :options="input.options" value="" hint={input.description}></ui-select>
{:else}
<ui-input name={input.name} label={input.name} placeholder={input.placeholder} hint={input.description} required={input.required}></ui-input>
{/if}
{/each}
</div>
{/if}
<div class="bar">
<ui-button type="submit" variant="primary" icon="paper-plane-right" label="Send request" loading={state.sending}></ui-button>
</div>
</form>

{#if state.response}
<div class="result-slot">
<ui-card padding="none">
<div class="result">
<div class="head">
<ui-badge tone={state.response.ok ? 'success' : 'danger'} label="{state.response.status}"></ui-badge>
<span>{state.response.ms} ms</span>
</div>
<pre>{state.response.text}</pre>
</div>
</ui-card>
</div>
{/if}`
};
}

Fez('api-try', __fez_component_0);

export default __fez_component_0;
